import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import clsx from 'clsx';

const DropdownItem = ({
  className,
  disabled,
  divider,
  href,
  icon,
  target,
  textId,
  onClick,
}) => {
  const intl = useIntl();
  return (
    <>
      {divider && (<Dropdown.Divider />)}
      <Dropdown.Item
        as="a"
        className={clsx('aridhia-dropdown', 'primary', className)}
        disabled={disabled}
        href={disabled ? undefined : href}
        icon={icon}
        target={target}
        text={intl.formatMessage({ id: textId })}
        onClick={disabled ? undefined : onClick}
      />
    </>
  );
};

export default DropdownItem;
